import React, { memo, useMemo } from 'react'
import { Avatar } from 'transfix-ui/components/Avatar'
import { TableCell } from 'transfix-ui/components/Table'
import { LaneAlert } from 'apps/marketplace/apiTypes/carrierLaneAlerts'
import { formatRelativeDate } from './utils'

interface ISavedLanesTableAddedByCellProps
  extends Pick<LaneAlert, 'id' | 'createdAt' | 'createdBy' | 'updatedAt'> {}

export const SavedLanesTableAddedByCell = memo(
  ({ createdAt, createdBy, id, updatedAt }: ISavedLanesTableAddedByCellProps) => {
    const { firstName, lastName } = createdBy || {}
    const authorName = useMemo(() => `${firstName} ${lastName}`, [firstName, lastName])
    const timestamp = useMemo(() => {
      if (updatedAt) {
        return `Edited ${formatRelativeDate(updatedAt)}`
      }
      return `Added ${formatRelativeDate(createdAt)}`
    }, [createdAt, updatedAt])

    return (
      <TableCell dataTest={`saved-lane-${id}-added-by`}>
        <Avatar name={authorName} details={timestamp} />
      </TableCell>
    )
  }
)
